export interface Integration {
  id: string;
  provider: string;
  category: 'email' | 'crm' | 'google' | 'webhook';
  is_active: boolean;
  environment: 'sandbox' | 'production';
  config_json: Record<string, unknown>;
  last_tested_at: string | null;
  last_status: 'connected' | 'error' | 'untested';
  last_error: string | null;
  created_at: string;
  updated_at: string;
}

export interface OutgoingWebhook {
  id: string;
  name: string;
  endpoint_url: string;
  secret: string | null;
  events: string[];
  is_active: boolean;
  description: string | null;
  last_triggered_at: string | null;
  last_status: 'success' | 'error' | 'untested';
  created_at: string;
  updated_at: string;
}

export interface IntegrationLog {
  id: string;
  integration_id: string | null;
  webhook_id: string | null;
  event_type: string;
  status: 'success' | 'error';
  message: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

export const WEBHOOK_EVENTS = [
  { value: 'user.created', label: 'Usuário criado' },
  { value: 'user.deleted', label: 'Usuário removido' },
  { value: 'subscription.created', label: 'Assinatura criada' },
  { value: 'subscription.cancelled', label: 'Assinatura cancelada' },
  { value: 'subscription.upgraded', label: 'Plano atualizado' },
  { value: 'payment.received', label: 'Pagamento recebido' },
  { value: 'payment.failed', label: 'Pagamento falhou' },
  { value: 'payment.refunded', label: 'Pagamento estornado' },
  { value: 'trial.started', label: 'Trial iniciado' },
  { value: 'trial.expired', label: 'Trial expirado' },
];
